import {Component, ChangeDetectionStrategy} from '@angular/core';
import {BaseAppComponent} from '../_base-app/base-app.component';
import {Store} from '@ngrx/store';
import {AppState} from '../../../app/app.state';
import {ActivatedRoute, RouterOutlet} from '@angular/router';
import {AsideService} from '../../../core/services/aside.service';
import {UrlService} from '../../../core/services/url.service';
import {App, AppId} from '../../../shared/models/app';
import {TitleChangedAction} from '../../../core/actions/title.actions';
import {SessionService} from '../../../core/services/session.service';
import { PermissionsService } from 'src/core/services/permissions.service';
import { ObjectModel } from '../../../shared/models/object.model';
import { Permission } from 'src/shared/models/fga/permission';
import { ObjectType } from 'src/shared/models/object.model';
import {MotiChatService} from '../../../moti/services/moti-chat.service';

@Component({
  selector: 'motn-app-picture',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app-mosaic.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterOutlet,
  ],
})
export class AppMosaicComponent extends BaseAppComponent {
  app: App;
  appId: AppId;


  constructor(
    protected store: Store<AppState>,
    protected route: ActivatedRoute,
    protected session: SessionService,
    protected permissionsService: PermissionsService,
    private asideService: AsideService,
    private motiChatService: MotiChatService,
  ) {
    super(store, route, session, permissionsService);
  }


  protected onInit() {
    // Set a temporary empty title immediately to prevent showing "Manage Apps"
    // The actual app name will be set once data loads
    this.store.dispatch(new TitleChangedAction(
      '',
      '',
      [],
      null,
    ));
  }


  protected onDestroy() {
  }


  protected updateTitle() {
    const subtitleItems = [];
    
    if (this.canChat) {
      subtitleItems.push({
        text: 'Chat',
        icon: 'kit:chat',
        callback: () => this.openAppChat()
      });
    }
    
    if (this.app.Config?.Subtitle?.Text) {
      subtitleItems.push({text: this.app.Config.Subtitle.Text});
    }

    this.store.dispatch(new TitleChangedAction(
      '',
      this.app.Name,
      subtitleItems,
      this.app.Config?.Location,
    ));
  }

  private openAppChat(): void {
    if (this.app) {
      this.motiChatService.openChat(this.app.ID, this.app.Name, ObjectType.APP);
    }
  }

  protected updateAside(): void {
    const items = [
      {
        text: 'Dashboard',
        path: UrlService.makeMosaicDashboardUrl(this.appId),
      },
    ];

    if (this.canConfigure) {
      items.push({
        text: 'Configuration',
        path: UrlService.makeMosaicConfigurationUrl(this.appId),
      });
    }

    const mosaicSection = {
      name: 'Mosaic',
      items: items,
      shareSubject: ObjectModel.fromApp(this.app),
    };

    this.asideService.replaceContextSections([mosaicSection]);
  }

}
